export default __webpack_public_path__ + "static/media/MDA.936018eb.png";